import adminApi from './admin'
import contentApi from './content-api'

export default {
  admin: adminApi,
  'content-api': contentApi,
}
